/* KISEL PDP: colour + size -> variant (native id + ?variant=), prices, gallery filtered by colour, 7-day offer timer,
   "activate my -40%" button, KISEL cart drawer after add, section loops. */
(function () {
  var V = [];
  try { V = JSON.parse(document.getElementById('ki-variants').textContent); } catch (e) {}
  var form = document.querySelector('form[data-ki-add]');
  var idInp = form ? form.querySelector('input[name=id]') : null;
  var cols = [].slice.call(document.querySelectorAll('[data-ki-col]'));
  var sizes = [].slice.call(document.querySelectorAll('[data-ki-size]'));
  var q = function (s) { return document.querySelector(s); };
  var cur = V.filter(function (x) { return idInp && String(x.id) === idInp.value; })[0] || V[0];
  if (!cur) return;
  var state = { c: cur.c, s: cur.s };

  /* gallery */
  var gal = q('[data-ki-gal]');
  var imgs = gal ? [].slice.call(gal.querySelectorAll('.ki-gal__main img')) : [];
  var thumbs = gal ? [].slice.call(gal.querySelectorAll('.ki-gal__thumbs button')) : [];
  var vis = [], at = 0;
  function show(i) {
    if (!vis.length) return;
    at = (i + vis.length) % vis.length;
    imgs.forEach(function (el, k) { el.classList.toggle('is-on', k === vis[at]); });
    thumbs.forEach(function (el, k) { el.classList.toggle('is-on', k === vis[at]); });
  }
  function filter(col) {
    vis = [];
    imgs.forEach(function (el, k) {
      var c = el.getAttribute('data-col');
      var ok = c === 'All' || c === col;
      if (thumbs[k]) thumbs[k].hidden = !ok;
      if (ok) vis.push(k);
    });
    if (!vis.length) vis = imgs.map(function (_, k) { return k; });
    show(0);
  }
  if (gal) {
    thumbs.forEach(function (b, k) { b.addEventListener('click', function () { var i = vis.indexOf(k); if (i > -1) show(i); }); });
    gal.querySelectorAll('[data-dir]').forEach(function (b) { b.addEventListener('click', function () { show(at + parseInt(b.dataset.dir, 10)); }); });
    var main = gal.querySelector('.ki-gal__main'), x0 = null;
    main.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
    main.addEventListener('touchend', function (e) {
      if (x0 === null) return; var dx = e.changedTouches[0].clientX - x0;
      if (Math.abs(dx) > 40) show(at + (dx < 0 ? 1 : -1)); x0 = null;
    });
  }

  function find(c, s) { return V.filter(function (x) { return x.c === c && x.s === s; })[0]; }
  function pct(x) { return x.cc > x.pc ? Math.floor((x.cc - x.pc) * 100 / x.cc) : 0; }
  function render(push) {
    var v = find(state.c, state.s); if (!v) return;
    cur = v;
    if (idInp && idInp.value !== String(v.id)) { idInp.value = v.id; idInp.dispatchEvent(new Event('change', { bubbles: true })); }
    cols.forEach(function (b) { b.classList.toggle('is-on', b.getAttribute('data-ki-col') === state.c); });
    sizes.forEach(function (b) {
      b.classList.toggle('is-on', b.getAttribute('data-ki-size') === state.s);
      var x = find(state.c, b.getAttribute('data-ki-size'));
      var el = b.querySelector('[data-ki-sp]');
      if (x && el) el.innerHTML = x.p + (x.cc > x.pc ? '<s>' + x.cp + '</s>' : '');
    });
    var set = function (sel, t) { var el = q(sel); if (el) el.textContent = t; };
    set('[data-ki-colname]', state.c); set('[data-ki-sizename]', state.s);
    set('[data-ki-now]', v.p); set('[data-ki-was]', v.cp); set('[data-ki-atcp]', v.p);
    var sv = q('[data-ki-save]'); if (sv) sv.textContent = '−' + pct(v) + '%';
    var atc = form ? form.querySelector('[type=submit]') : null;
    if (atc) { atc.disabled = !v.a; set('[data-ki-atc]', v.a ? 'Add to cart' : 'Sold out'); }
    if (push) {
      try { var u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState(history.state, '', u.toString()); } catch (e) {}
      document.dispatchEvent(new CustomEvent('variant:change', { detail: { variantId: Number(v.id) } }));
    }
  }
  cols.forEach(function (b) { b.addEventListener('click', function () { state.c = b.getAttribute('data-ki-col'); render(true); filter(state.c); }); });
  sizes.forEach(function (b) { b.addEventListener('click', function () { state.s = b.getAttribute('data-ki-size'); render(true); }); });
  document.querySelectorAll('[data-ki-pick]').forEach(function (b) {
    b.addEventListener('click', function () {
      state.c = b.getAttribute('data-ki-pick'); render(true); filter(state.c);
      var top = q('#ki-top'); if (top) top.scrollIntoView({ behavior: 'smooth' });
    });
  });
  render(false); filter(state.c);

  /* 7-day offer timer: starts at the visitor's first visit (like the offer itself), restarts after it runs out */
  var WEEK = 7 * 864e5, t0 = 0;
  try { t0 = parseInt(localStorage.getItem('ki_t0') || '0', 10); } catch (e) {}
  if (!t0 || Date.now() - t0 >= WEEK) { t0 = Date.now(); try { localStorage.setItem('ki_t0', String(t0)); } catch (e) {} }
  var tm = q('[data-ki-timer]');
  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function tick() {
    if (!tm) return;
    var left = Math.max(0, t0 + WEEK - Date.now()), s = Math.floor(left / 1000);
    var d = Math.floor(s / 86400), h = Math.floor(s % 86400 / 3600), m = Math.floor(s % 3600 / 60);
    tm.querySelector('[data-t=d]').textContent = pad(d); tm.querySelector('[data-t=h]').textContent = pad(h);
    tm.querySelector('[data-t=m]').textContent = pad(m); tm.querySelector('[data-t=s]').textContent = pad(s % 60);
  }
  tick(); setInterval(tick, 1000);
  var offer = q('[data-ki-offer]'), ok = q('[data-ki-ok]'), act = q('[data-ki-activate]');
  function on() { if (offer) offer.classList.add('is-on'); if (ok) ok.hidden = false; }
  try { if (localStorage.getItem('ki_on') === '1') on(); } catch (e) {}
  if (act) act.addEventListener('click', function () { on(); try { localStorage.setItem('ki_on', '1'); } catch (e) {} });

  /* add to cart -> KISEL drawer */
  if (form) {
    form.addEventListener('submit', function (e) {
      if (e.defaultPrevented) return;
      e.preventDefault();
      var btn = form.querySelector('[type=submit]'); btn.disabled = true;
      fetch('/cart/add.js', { method: 'POST', credentials: 'same-origin', headers: { 'Accept': 'application/json' }, body: new FormData(form) })
        .then(function (r) { if (!r.ok) throw new Error('add'); btn.disabled = false; if (window.KI) window.KI.openCart(); })
        .catch(function () { btn.disabled = false; form.submit(); });
    });
  }

  var vids = document.querySelectorAll('[data-ki-loop]');
  if (vids.length && 'IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) e.target.play().catch(function () {}); else e.target.pause(); }); }, { threshold: 0.4 });
    vids.forEach(function (v) { io.observe(v); });
  }
})();

/* ===== 10-02 (Edvin): Add to cart NEVER goes to /cart - every add (theme ATC, Kaching ATC, any /cart/add form) opens the KI brand cart drawer ===== */
(function () {
  if (window.__ki_atc) return; window.__ki_atc = 1;
  function open() { if (window.KI && window.KI.openCart) return window.KI.openCart(); if (window.__lntOpen) return window.__lntOpen(); }
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f || !f.getAttribute || !/\/cart\/add/.test(f.getAttribute('action') || '')) return;
    if (e.defaultPrevented) return;
    e.preventDefault();
    var b = f.querySelector('[type=submit]'); if (b) b.disabled = true;
    var fd = new FormData(f), tries = 0;
    (function add() {
      fetch('/cart/add.js', { method: 'POST', credentials: 'same-origin', headers: { 'Accept': 'application/json' }, body: fd })
        .then(function (r) {
          if (r.ok) { if (b) b.disabled = false; return open(); }
          if (r.status === 422) return r.json().then(function (j) { if (b) b.disabled = false; open(); if (j && j.description) alert(j.description); });
          throw new Error('add ' + r.status);
        })
        .catch(function () { if (++tries < 2) return setTimeout(add, 800); /* 10-06: bot check (429) or network -> normal form POST, back to this page (?opencart=1), drawer opens. Never /cart, never an alert */ try { var u = new URL(location.href); u.searchParams.set('opencart', '1'); var h = document.createElement('input'); h.type = 'hidden'; h.name = 'return_to'; h.value = u.pathname + u.search; f.appendChild(h); } catch (x) {} HTMLFormElement.prototype.submit.call(f); });
    })();
  }, false);
})();

/* 10-06: back from the fallback POST (?opencart=1) -> open the brand cart drawer and clean the URL */
(function () {
  try { var u = new URL(location.href); if (u.searchParams.get('opencart') !== '1') return; u.searchParams.delete('opencart'); history.replaceState(null, '', u.pathname + u.search + u.hash); } catch (e) { return; }
  var n = 0, t = setInterval(function () { var ok = false; for (var k in window) { if (/^[A-Z]{2,4}$/.test(k) && window[k] && typeof window[k].openCart === 'function') { window[k].openCart(); ok = true; break; } } if (!ok && window.__lntOpen) { window.__lntOpen(); ok = true; } if (ok || ++n > 40) clearInterval(t); }, 150);
})();
